module.exports = __webpack_public_path__ + "img/app2.9413af31.png";